import React from "react";
import { Avatar } from "@material-ui/core";

const ProfileImg = ({ image }) => {
  return (
    <Avatar
      alt="image"
      src={image ? image : ""}
      style={{
        borderRadius: "100%",
        width: "100%",
        height: "100%",
        background: "rgba(255,255,255,0.9)",
      }}
    />
  );
};

export default ProfileImg;
